import { ExclamationCircleIcon } from '@app/features/analytics/icons/exclamation-circle';
import { useTranslation } from '@hopin-team/provider-translation';
import cx from 'classnames';
import React from 'react';

type FormControlProps = {
  id: string;
  label?: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  hideLabel?: boolean;
  children?: React.ReactNode;
};

export const FormControl = ({
  id,
  label,
  error,
  required,
  className,
  hideLabel,
  children,
}: FormControlProps) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={cx(
          'font-inter mb-1 block text-xs font-medium text-gray-700',
          {
            'sr-only': hideLabel,
          },
        )}
      >
        {label}{' '}
        {required && (
          <span className="text-gray-600">({t('common.required')})</span>
        )}
      </label>
      {children}
      {error && (
        <div
          id={`${id}-error`}
          className="font-inter mt-1 flex items-center text-main-text text-red-500"
        >
          <ExclamationCircleIcon className="mr-2" />
          {error}
        </div>
      )}
    </div>
  );
};
